"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadLocale = loadLocale;
var _en = _interopRequireDefault(require("./en"));
var _fr = _interopRequireDefault(require("./fr"));
var _ru = _interopRequireDefault(require("./ru"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var supportedLocales = {
  en: _en["default"],
  fr: _fr["default"],
  ru: _ru["default"]
};
var defaultLocale = 'en';
function loadLocale(code) {
  return supportedLocales[code] ? supportedLocales[code] : supportedLocales[defaultLocale];
}